module.exports = "https://cdn-challenge.mathletics.com/app/111/assets/images/e97815cd752f54e49980dd43d111a911.svg";